import { render, staticRenderFns } from "./BranchManagement.vue?vue&type=template&id=4078b4f3"
import script from "./BranchManagement.vue?vue&type=script&lang=js"
export * from "./BranchManagement.vue?vue&type=script&lang=js"
import style0 from "./BranchManagement.vue?vue&type=style&index=0&id=4078b4f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports